<div class="auth-shell">
  <div class="auth-card">
    <div class="brand">
      <div class="logo-badge">
        <img src="/brand/inbordo-logo.svg" alt="InBordo" />
      </div>
      <div>
        <h1>{{ 'auth.login.title' | translate }}</h1>
        <p>{{ 'auth.login.subtitle' | translate }}</p>
      </div>
    </div>

    <div class="mode-toggle">
      <button
        type="button"
        [class.active]="mode === 'email'"
        (click)="mode = 'email'"
      >
        {{ 'auth.login.emailPassword' | translate }}
      </button>
      <button
        type="button"
        [class.active]="mode === 'otp'"
        (click)="mode = 'otp'"
      >
        {{ 'auth.login.phoneOtp' | translate }}
      </button>
    </div>

    <form class="form" (ngSubmit)="submit()">
      <ng-container *ngIf="mode === 'email'">
        <label>
          {{ 'auth.login.email' | translate }}
          <input type="email" [(ngModel)]="email" name="email" placeholder="name@company.com" />
        </label>
        <label>
          {{ 'auth.login.password' | translate }}
          <input type="password" [(ngModel)]="password" name="password" placeholder="••••••••" />
        </label>
        <a class="helper" routerLink="/reset">{{ 'auth.login.forgot' | translate }}</a>
      </ng-container>

      <ng-container *ngIf="mode === 'otp'">
        <label>
          {{ 'auth.login.phone' | translate }}
          <input type="tel" [(ngModel)]="phone" name="phone" placeholder="+90 5xx xxx xx xx" />
        </label>
        <label>
          {{ 'auth.login.otp' | translate }}
          <input type="text" [(ngModel)]="otp" name="otp" placeholder="6-digit code" />
        </label>
        <button type="button" class="ghost" (click)="sendOtp()" [disabled]="loading">
          {{ 'auth.login.sendOtp' | translate }}
        </button>
      </ng-container>

      <button type="submit" class="primary" [disabled]="loading">
        {{ loading ? ('auth.login.signingIn' | translate) : ('auth.login.signIn' | translate) }}
      </button>
    </form>

    <div class="footer">
      <span>{{ 'common.language' | translate }}</span>
      <button class="ghost" (click)="toggleLocale()">{{ localeLabel }}</button>
    </div>
  </div>

  <div class="auth-panel">
    <div class="logo-badge">
      <img src="/brand/inbordo-logo.svg" alt="InBordo" />
    </div>
    <p>{{ 'auth.panel.tagline' | translate }}</p>
    <div class="highlights">
      <div>
        <span>{{ 'auth.panel.liveOps' | translate }}</span>
        <strong>{{ 'auth.panel.accessCheckins' | translate }}</strong>
      </div>
      <div>
        <span>{{ 'auth.panel.finance' | translate }}</span>
        <strong>{{ 'auth.panel.billingPos' | translate }}</strong>
      </div>
      <div>
        <span>{{ 'auth.panel.retention' | translate }}</span>
        <strong>{{ 'auth.panel.programsCrm' | translate }}</strong>
      </div>
    </div>
  </div>
</div>
